import type { GameAnalyticsEvent } from 'vue3-game-analytics';

export type AnalyticsTrackEventFn = (
  event: Partial<GameAnalyticsEvent>
) => void;

let trackEventFn: AnalyticsTrackEventFn | null = null;

export function setAnalyticsTrackEvent(fn: AnalyticsTrackEventFn) {
  trackEventFn = fn;
}

export function trackAnalyticsEvent(event: Partial<GameAnalyticsEvent>) {
  try {
    trackEventFn?.(event);
  } catch (error) {
    // Never throw from analytics helpers (often called from error handlers)
    console.warn('[Analytics] Failed to track event', error);
  }
}
